import React from 'react';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { CommentDisplay } from 'component/CommentBlock';
import { AccordionHeaderTitle } from 'component/Accordion';
import { useHAReports } from 'hooks/useHAReports';
import { DirectEvidencesView } from './DirectEvidences';
import { IndirectEvidencesView } from './IndirectEvidences';

export const EvidencesView = (props) => {
  const {
    formData, comments,
    translatedFormData,
    translateState,
  } = props;

  const haReportsDirectHook = useHAReports(props?.map1);
  const haReportsIndirectHook = useHAReports(props?.map2);

  const haReportsDirect = props?.haReportsDirect || haReportsDirectHook;
  const haReportsIndirect = props?.haReportsIndirect || haReportsIndirectHook;

  return (
    <AccordionItem uuid="evidence">
      <AccordionItemHeading>
        <AccordionItemButton>
          <AccordionHeaderTitle
            accordionId="4"
            titleUA="Докази *"
            titleEN="Evidence"
          />
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <DirectEvidencesView
          formData={formData}
          map={props?.map1}
          setMap={props?.setMap1}
          translatedFormData={translatedFormData}
          translateState={translateState}
          haReports={haReportsDirect}
        />
        <IndirectEvidencesView
          formData={formData}
          map={props?.map2}
          setMap={props?.setMap2}
          translatedFormData={translatedFormData}
          translateState={translateState}
          haReports={haReportsIndirect}
        />
        <CommentDisplay comments={comments} block="evidences" />
      </AccordionItemPanel>
    </AccordionItem>
  );
};
